<ng-container thr-parent-form>
    <div class="bg-gray">
        <div class="container">
            <div class="row">
                <!--Nuevo ADV-2351-->
            <div class="col-12">
                <div class="product-summary">
                <ng-container *ngIf="canExonerate">
                    <div class="py-4 py-md-0">
                        <label class="mb-0">
                            {{ 'product.convenience' | translate }}
                            <span class="appropriateness ml-4" [class.not-appropriateness]="!selectedProduct.isAppropriateness">
                                <mat-icon>check</mat-icon>
                            </span>
                        </label>
                    </div>
                    <div class="d-flex">
                        <label class="mt-1 mb-0 mt-md-0">{{ 'product.exonerate' | translate }}</label>
                        <mat-radio-group class="ml-4" [disabled]="true" *ngIf="selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group class="ml-4" [disabled]="!editable" name="isExonerated" [(ngModel)]="selectedProduct.isExonerated" (ngModelChange)="onExonerate()" *ngIf="!selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>
                </div>
            </div>
            <!--Fin de Nuevo ADV-2351-->
                <div class="col-12">
                    <!-- <div class="mt-3">
                        <label>{{ 'form.fondoorigen'|translate }}</label>
                    </div>
                    <mat-form-field class="full-width pt-2 mb-4"> -->
                    <mat-form-field class="full-width pt-2 my-4">
                        <mat-select
                            name="targetProduct"
                            [placeholder]="'form.select-between-your-products' | translate"
                            required
                            [disabled]="!editable"
                            [(ngModel)]="selectedProduct.order.internalTransferCode"
                            (ngModelChange)="onTargetProductChange()"
                            #targetProductCtrl="ngModel"
                        >
                            <mat-option *ngFor="let product of internalProducts" [value]="product.encryptedCode.value">
                                {{ product.name }} ({{ product.amount | number: '1.0-2' }}&euro;)
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="targetProductCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <mat-label class="d-block text-blue my-4">
                    {{ 'form.options-internal-transfer' | translate }}
                </mat-label>

                <mat-radio-group
                    name="action"
                    [(ngModel)]="selectedProduct.order.action"
                    (ngModelChange)="onActionChange()"
                    [required]="true"
                    [disabled]="!internalProduct || !editable"
                >
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <mat-radio-button class="d-block" name="actionTotal" color="blue-gray" [value]="OrderAction.TOTAL">
                                {{ 'form.total' | translate }}
                            </mat-radio-button>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <mat-radio-button class="d-block" name="actionShares" color="blue-gray" [value]="OrderAction.SHARES">
                                {{ 'form.number-shares' | translate }}
                            </mat-radio-button>

                            <div class="ml-4 ml-sm-5">
                                <mat-form-field class="full-width">
                                    <input
                                        type="hidden"
                                        name="shares"
                                        [min]="minimumShares"
                                        [max]="maximumShares"
                                        [(ngModel)]="selectedProduct.order.internalTransferShares"
                                        #sharesCtrl="ngModel"
                                    />
                                    <input
                                        matInput
                                        #sharesDirective="auto-numeric"
                                        thr-auto-numeric
                                        [placeholder]="'form.indicates-number-shares' | translate"
                                        required
                                        [numDecimals]="8"
                                        [currencySymbol]="''"
                                        [disabled]="selectedProduct.order.action !== OrderAction.SHARES || !editable || !internalProduct"
                                        [value]="initialShares"
                                        (input)="onSharesChange()"
                                    />
                                </mat-form-field>
                                <div *ngIf="editable && selectedProduct.order.action === OrderAction.SHARES">
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="sharesCtrl.hasError('min') && !sharesCtrl.hasError('required')"
                                    >
                                        <ng-container *ngIf="!!minimumInvestmentMsg">
                                            {{
                                                minimumInvestmentMsg
                                                    | translate
                                                        : {
                                                              value: minimumInvestment | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                    </mat-error>
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="sharesCtrl.hasError('max') && !sharesCtrl.hasError('required')"
                                    >
                                        <ng-container *ngIf="internalProduct?.minimumAmountToMaintain > 0; else minimumZero">
                                            {{
                                                'form.validation.minimum-to-maintain-origin'
                                                    | translate
                                                        : {
                                                              value: internalProduct?.minimumAmountToMaintain | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                        <ng-template #minimumZero>
                                            {{ 'form.validation.cannot-transfer-more-than-you-have' | translate }}
                                        </ng-template>
                                    </mat-error>
                                    <mat-error class="d-block mat-caption" *ngIf="sharesCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <mat-radio-button class="d-block" name="actionAmount" color="blue-gray" [value]="OrderAction.AMOUNT">
                                {{ 'form.for-amount' | translate }}:
                            </mat-radio-button>

                            <div class="ml-4 ml-sm-5">
                                <mat-form-field class="full-width no-padding-bottom" [class.mat-form-field-invalid]="amountCtrl.invalid">
                                    <input
                                        type="hidden"
                                        name="amount"
                                        [min]="minimumInvestment"
                                        [max]="maximumInvestment"
                                        [(ngModel)]="selectedProduct.order.internalTransferAmount"
                                        #amountCtrl="ngModel"
                                    />
                                    <input
                                        matInput
                                        #amountDirective="auto-numeric"
                                        thr-auto-numeric
                                        [placeholder]="'form.amount' | translate"
                                        required
                                        [disabled]="selectedProduct.order.action !== OrderAction.AMOUNT || !editable || !internalProduct"
                                        [value]="initialAmount"
                                        (input)="onAmountChange()"
                                    />
                                </mat-form-field>
                                <div *ngIf="editable && selectedProduct.order.action === OrderAction.AMOUNT">
                                    <mat-hint class="d-block mat-caption" *ngIf="!amountCtrl.errors">
                                        <ng-container *ngIf="!!minimumInvestmentMsg && minimumInvestment > 0">
                                            {{
                                                minimumInvestmentMsg
                                                    | translate
                                                        : {
                                                              value: minimumInvestment | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                    </mat-hint>
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="amountCtrl.hasError('min') && !amountCtrl.hasError('required')"
                                    >
                                        <ng-container *ngIf="!!minimumInvestmentMsg">
                                            {{
                                                minimumInvestmentMsg
                                                    | translate
                                                        : {
                                                              value: minimumInvestment | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                    </mat-error>
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="amountCtrl.hasError('max') && !amountCtrl.hasError('required')"
                                    >
                                        <ng-container *ngIf="internalProduct?.minimumAmountToMaintain > 0; else minimumZero">
                                            {{
                                                'form.validation.minimum-to-maintain-origin'
                                                    | translate
                                                        : {
                                                              value: internalProduct?.minimumAmountToMaintain | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                        <ng-template #minimumZero>
                                            {{ 'form.validation.cannot-transfer-more-than-you-have' | translate }}
                                        </ng-template>
                                    </mat-error>
                                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-radio-group>
            </div>
        </div>
    </div>
</ng-container>
